webpackJsonp([60],{

/***/ "P9ky":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-alert_9c9e0d89e7f6547e20bee94547b7b514.html";

/***/ }),

/***/ "urJj":
/***/ (function(module, exports, __webpack_require__) {

var SubscriptionAlert = (function () {
    function SubscriptionAlert() {
    }
    return SubscriptionAlert;
}());
angular.module('animatronApp.SubscriptionAlert', [])
    .component('subscriptionAlert', {
    bindings: {
        saTitle: '<',
        content: '<',
        buttonName: '<',
        onClick: '&'
    },
    controller: SubscriptionAlert,
    templateUrl: __webpack_require__("P9ky")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/60-0e7693f8a3788edda5d0.min.js